const b64DecodeUnicode = (str: string) => {
  return decodeURIComponent(
    Array.prototype.map
      .call(window.atob(str), function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
};

export default b64DecodeUnicode;
